import React, { useContext } from "react";
import { ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import ExitToAppTwoToneIcon from "@mui/icons-material/ExitToAppTwoTone";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { mensagem_tem_a_certeza_sair } from "../../Func_genericas/valores_estaticos";

export const OpcaoSair = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [open_modal_tem_a_certeza_que_quer_sair, set_open_modal_tem_a_certeza_que_quer_sair] = React.useState(false);

  const handleCloseDialog = () => {
    set_open_modal_tem_a_certeza_que_quer_sair(false)
    handleLogout()
  };

  const handleLogout = () => {


    auth.signout();
    navigate('/')
    auth.func_set_user_role("");
  };

  return (
    <>
      <ListItemButton onClick={() => {
        set_open_modal_tem_a_certeza_que_quer_sair(true)
      }}>
        <ListItemIcon>
          <ExitToAppTwoToneIcon sx={{ color: "#c94f1e" }} />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography style={{ fontFamily: "candara", fontSize: 16 }}>
              Sair
            </Typography>
          }
        />

      </ListItemButton>

      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_sair}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_sair(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_sair}
      />
    </>
  )
}